import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../Contexts/AuthContext";

const RequireAuth = () => {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (user.requiresContactInfoUpdate && location.pathname !== "/completar-cadastro") {
    return <Navigate to="/completar-cadastro" replace />;
  }

  return <Outlet />;
};

export default RequireAuth;
